import { USER_EVENTS } from '@shared/core/user-events'
import { isKalamaTeaserActive } from 'src/modules/brand/utils/kalama-branding'
import { isAccountOldEnoughForKalamaNotice } from 'src/modules/brand/utils/kalama-notice'
import { ALERT_CAMPAIGN_IDS, ALERT_CAMPAIGN_PRIORITIES, ALERT_CAMPAIGN_SEEN_EVENTS } from '../alerts.constants'
import type { AlertCampaign, AlertContext } from '../alerts.types'
import { isKalamaTeaserPopupShownInTab } from './kalama-teaser-modal.domain'

export const kalamaTeaserModalCampaign: AlertCampaign = {
  id: ALERT_CAMPAIGN_IDS.KALAMA_TEASER,
  priority: ALERT_CAMPAIGN_PRIORITIES.KALAMA_TEASER,
  seenEventName: ALERT_CAMPAIGN_SEEN_EVENTS[ALERT_CAMPAIGN_IDS.KALAMA_TEASER],
  isEligible: isEligibleForKalamaTeaserModal,
}

function isEligibleForKalamaTeaserModal({ profile, userEvents }: AlertContext): boolean {
  if (!isKalamaTeaserActive() || profile === null) return false
  if (userEvents.has(USER_EVENTS.KALAMA_TEASER_WEB_POPUP_SEEN)) return false
  if (isKalamaTeaserPopupShownInTab(profile.id)) return false

  return isAccountOldEnoughForKalamaNotice(profile.created_at, new Date())
}
